<template>
  <div id="div-design-form" class="vs-con-loading__container">
    <div class="flex fixed flex-col items-end justify-end right-0" style="top: 9.5rem; z-index: 1000">
      <vx-tooltip :text="$t('MODULE.saveForm')" position="left">
        <feather-icon
          v-if="thereAreQuestions"
          icon="SaveIcon"
          class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer mb-3"
          @click="saveForm()"
          :svgClasses="{
            'text-primary stroke-current': true
          }"
        />
      </vx-tooltip>

      <vx-tooltip :text="$t('MODULE.downloadJson')" position="left">
        <feather-icon
          v-if="thereAreQuestions"
          @click="donwloadJson"
          icon="DownloadIcon"
          class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer mb-3"
          :svgClasses="{
            'text-primary stroke-current': true
          }"
        />
      </vx-tooltip>

      <vx-tooltip :text="$t('MODULE.cleanForm')" position="left">
        <feather-icon
          v-if="thereAreQuestions"
          @click="clearForm()"
          icon="TrashIcon"
          class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer mb-3"
          :svgClasses="{
            'text-primary stroke-current': true
          }"
        />
      </vx-tooltip>

      <vx-tooltip :text="$t('MODULE.listForms')" position="left">
        <feather-icon
          icon="FilePlusIcon"
          @click="addNewForm()"
          class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer mb-3"
          :svgClasses="{
            'text-primary stroke-current': true
          }"
        />
      </vx-tooltip>

      <vx-tooltip :text="$t('MODULE.openForm')" position="left">
        <feather-icon
          icon="BookOpenIcon"
          @click="openPupopForms()"
          class="p-2 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer"
          :svgClasses="{
            'text-primary stroke-current': true
          }"
        />
      </vx-tooltip>
    </div>
    <div class="ais-InstantSearch" id="algolia-instant-search-demo">
      <div class="algolia-header mb-4">
        <div class="flex md:items-end items-center justify-between flex-wrap">
          <!-- TOGGLE SIDEBAR BUTTON -->
          <feather-icon
            class="inline-flex lg:hidden cursor-pointer mr-4"
            icon="MenuIcon"
            @click.stop="toggleFilterSidebar"
          />
        </div>
      </div>
      <div id="algolia-content-container" class="relative clearfix mr-2" style="min-height: 200px">
        <CardPages></CardPages>
        <!-- END SIDEBAR -->
        <!-- CONTAINER TO BUILD QUIESTIONS -->
        <div :class="{ 'sidebar-spacer-with-margin': clickNotClose }">
          <vs-tabs alignment="center">
            <vs-tab label="Builder">
              <div id="sidebar-content-container">
                <ItemForm v-for="(item, index) in questionsByPage" :key="index" :index="index"></ItemForm>
              </div>
              <vs-row vs-type="flex" vs-justify="center">
                <vs-col class="px-2" vs-lg="4" vs-sm="12" vs-xs="12">
                  <!-- ACTION CREATE QUESTIONS -->
                  <div
                    @click="question(1)"
                    class="
                      item-view-secondary-action-btn
                      mx-4
                      my-3
                      p-3
                      flex flex-grow
                      items-center
                      justify-center
                      text-white
                      cursor-pointer
                      rounded
                      btn-active
                    "
                  >
                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">{{ $t(createQuestion) }}</span>
                  </div>
                  <!-- END HTML CREATE QUESTIONS -->
                </vs-col>
                <vs-col class="px-2" vs-lg="4" vs-sm="12" vs-xs="12">
                  <!-- ACTION FOR CREATE COMPOENENTS -->
                  <div
                    @click="question(2)"
                    class="
                      item-view-secondary-action-btn
                      bg-primary
                      mx-4
                      my-3
                      p-3
                      flex flex-grow
                      items-center
                      justify-center
                      text-white
                      cursor-pointer
                      rounded
                    "
                    style="background: #7367f0"
                  >
                    <feather-icon icon="ShoppingBagIcon" svgClasses="h-4 w-4" />
                    <span class="text-sm font-semibold ml-2">{{ $t(createComponent) }}</span>
                  </div>
                  <!-- END HTML CREATE COMPONENTS -->
                </vs-col>
              </vs-row>
            </vs-tab>
            <vs-tab label="Code" @click="getFormulario">
              <div style="min-height: 70px">
                <json-viewer :value="visualCode" :expand-depth="5" theme="my-awesome-json-theme" copyable></json-viewer>
                <!-- {{allQuestions}} -->
              </div>
            </vs-tab>
          </vs-tabs>
        </div>
        <!--END CONTAINER TO BUILD QUIESTIONS -->
        <!-- <ButtomTopSave /> -->
      </div>
    </div>
    <component :is="componentPopup"></component>
  </div>
</template>

<script type="text/javascript">
import mixin from "./mixin/methods.js";
import draggable from "vuedraggable";
import ItemForm from "./CardQuestion/Question.vue";
import CardPages from "./Sidebar.vue";
import { Modals } from "./components/Modals/modals.js";
import { mapActions, mapState, mapMutations, mapGetters } from "vuex";
import { setQuestion, existFormById, clearIndexDbByIdForm, getFormVersion, ativeOneForm,
  inactiveAllForms } from "@/serviforms/designer/indexDB/logic.js";

import { _Permissions } from "@/acl/permitions.js";

export default {
  components: { draggable, ItemForm, CardPages, ...Modals },
  data() {
    return {
      questionWatch: [],
      currentPage: 0,
      isSubForm: "1",
      isMove: false,
      disabledGroup: false,
      visualCode: [],
      styles: {
        width: "60%",
        height: "564px"
      }
    };
  },
  mixins: [mixin, _Permissions],
  methods: {
    ...mapMutations("resource", ["UPDATE_STATE", "ADD_QUESTION", "CLEAR_DATA"]),
    setSidebarWidth() {
      if (this.windowWidth < 992) {
        this.UPDATE_STATE({
          key: "isFilterSidebarActive",
          value: false
        });
        this.UPDATE_STATE({ key: "clickNotClose", value: false });
      } else {
        this.UPDATE_STATE({
          key: "isFilterSidebarActive",
          value: true
        });
        this.UPDATE_STATE({ key: "clickNotClose", value: true });
      }
    },
    toggleFilterSidebar() {
      if (this.clickNotClose) return;
      this.UPDATE_STATE({
        key: "isFilterSidebarActive",
        value: !this.isFilterSidebarActive
      });
    },
    openPupopForms() {
      setQuestion();
      this.UPDATE_STATE({ key: "componentPopup", value: "ListForms" });
      this.UPDATE_STATE({ key: "activePopup", value: true });
    },
    async addNewForm() {
      const key = await this.createForm();
      this.selectedForm(key);
    },
    async selectedForm(key) {
      await inactiveAllForms();
      await ativeOneForm(key);
      this.runApp(key);
      this.UPDATE_STATE({ key: "activePopup", value: false });
    },
    ...mapActions("resource", [
      "addQuestion",
      "getSubformularios",
      "getOrigins",
      "saveFormAction",
      "validator",
      "updateFormAction",
      "runApp",
      "createForm"
    ])
  },
  computed: {
    ...mapState("resource", [
      "isFilterSidebarActive",
      "clickNotClose",
      "questionsByPage",
      "counter",
      "allPages",
      "idForm",
      "indexQuestionSetting",
      "questionsByPage",
      "componentPopup",
      "activePopup",
      "dataSidebar"
    ]),
    ...mapGetters("resource", ["thereAreQuestions"]),
    createQuestion() {
      if (this.questionsByPage.length === 0) return "MODULE.btnAddQuestion";
      return "MODULE.btnAddQuestionOteher";
    },
    createComponent() {
      if (this.questionsByPage.length === 0) return "MODULE.btnAddComponent";
      return "MODULE.btnAddComponentOther";
    },
    windowWidth() {
      return this.$store.state.windowWidth;
    }
  },
  watch: {
    windowWidth() {
      this.setSidebarWidth();
    }
  },
  async mounted() {
    this.$vs.loading({
      // container: '#div-design-form',
      scale: 0.6
    });

    const paramsId = this.$route.params.id;
    const paramsVersion = this.$route.params.last;
    this.setSidebarWidth();
    if(this.CheckPermision('data_origin')) this.getOrigins();
    if(this.CheckPermision('sub_forms')) this.getSubformularios();

    if (!!paramsId) {
      const existForm = await getFormVersion(paramsId, paramsVersion);
      const existRecord = await existFormById(paramsId);

      //NO EXISTE FORMULARIO CON EL ID Y LA VERSION
      if (existForm === null || existForm === undefined) {
        if (existRecord !== undefined) {
          await clearIndexDbByIdForm(paramsId);
        }
        await this.getForm(paramsId, paramsVersion);
      }
      await this.runApp(paramsId);
    } else {
      await this.runApp();
    }

    setTimeout(() => this.$vs.loading.close(), 2000);
  },
  destroyed() {
    this.CLEAR_DATA();
  }
};
</script>

<style type="text/css" lang="scss">
@import "./styles/style.scss";
@import "./styles/style-json-viewer.scss";

#sidebar-question .vs-input--label {
  font-weight: bold;
}

#sidebar-question .vs-select--label {
  font-weight: bold;
}
</style>
